const comments = [
  {
    name: '追剧达人小王',
    avatar: 'ri-user-3-line',
    time: '2 小时前',
    text: '樱花TV真的太良心了！不用注册不用付费，画质还这么高清，追日剧太方便了。《夏日烟火》每一集都看得停不下来！',
    tag: '日剧迷',
  },
  {
    name: '电影爱好者老李',
    avatar: 'ri-user-3-line',
    time: '5 小时前',
    text: '找了很久的欧美大片在这里都能看，4K画质真的绝了。推荐《星际迷航：新纪元》，特效炸裂，剧情也很有深度。',
    tag: '电影控',
  },
  {
    name: '剧荒拯救者',
    avatar: 'ri-user-3-line',
    time: '1 天前',
    text: '国产剧资源也很全，《长安十二时辰》全集已完结，一口气刷完太过瘾了。更新速度比很多平台都快，强烈推荐！',
    tag: '追剧族',
  },
  {
    name: '深夜看剧人',
    avatar: 'ri-user-3-line',
    time: '2 天前',
    text: '深夜睡不着就会打开樱花TV，日剧美剧随便挑。不缓冲这点太赞了，秒开秒播，体验感满分。希望一直运营下去！',
    tag: '夜猫子',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              观众热评
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              来看看大家都在追什么好剧
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-lg border border-background-200/60 p-5 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${comment.avatar} text-lg`} />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground-900 truncate">
                      {comment.name}
                    </p>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                  {comment.text}
                </p>
                <span className="inline-block mt-3 self-start px-2 py-0.5 text-xs font-medium rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {comment.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}